/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withFonts from '../with-fonts/with-fonts';
import { setUseWFFonts as _setUseWFFonts } from '../../lib/store/fonts/actions';
import globals from '../../lib/globals/globals'; // Note: useFontsWF is a prop used by DSM instead of defining useWFFonts in globals

var FontSupport = function FontSupport(_ref) {
  var useWFFonts = _ref.useWFFonts,
      setUseWFFonts = _ref.setUseWFFonts,
      _ref$useFontsWF = _ref.useFontsWF,
      useFontsWF = _ref$useFontsWF === void 0 ? false : _ref$useFontsWF;
  useEffect(function () {
    setUseWFFonts(globals().useWFFonts || useFontsWF || false);
  }, [setUseWFFonts]);
  useEffect(function () {
    document.body.classList[useWFFonts ? 'add' : 'remove']('bodyWFFonts');
    document.body.classList[useWFFonts ? 'add' : 'remove']('useWFFonts');
  }, [useWFFonts]);
  return null;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setUseWFFonts: function setUseWFFonts(useWFFonts) {
      return dispatch(_setUseWFFonts(useWFFonts));
    }
  };
};

export default compose(withFonts, connect(null, mapDispatchToProps))(FontSupport);